import styled from 'styled-components'

export const StyledTYP = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 32px;
  max-width: 640px;
  padding: 0 24px;
  margin: 0 auto;

  #password-btn-accedi {
    margin-top: 100px;
  }
`

export const StyledTitle = styled.div`
  color: #393935;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: 130%;
`

export const StyledContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  color: #393935;
  text-align: center;
  font-size: 18px;
  font-weight: 400;
  line-height: 135%;
`
